import React, { useState, useEffect } from "react";
import axios from "axios"; // adjust path as needed
import api, { PUBLIC_BASE_URL, BASE_URL } from "../Api/api";

const SubFaqPage = ({ id }) => {
  const [faqData, setFaqData] = useState([]);
  const [categoryName, setCategoryName] = useState("");

  useEffect(() => {
    api
      .get(`/faqsubservices/subservice/${id}`)
      .then((res) => {
        setFaqData(res.data.items);
        setCategoryName(res.data.category);
      })
      .catch((err) => console.error("FAQ Fetch Error", err));
  }, [id]);

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <section className="faq-section">
        <div className="faq-wrapper">
          <div className="faq-header">
            <small className="faq-label">— FAQ</small>
            <h2>Frequently Asked Questions - {categoryName}</h2>
            <p>
              Shiny Cleaner: Your Questions Answered, Your Space Transformed.
            </p>
          </div>

          <div className="faq-grid">
            {faqData.map((item, index) => (
              <div
                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                key={index}
              >
                <button
                  className="faq-question"
                  onClick={() => toggleFAQ(index)}
                >
                  <span className="icon">
                    {activeIndex === index ? "−" : "+"}
                  </span>
                  <span>{item.question}</span>
                </button>
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SubFaqPage;
